<template>
  <input
    :id
    :type
    v-model="inputValue"
    class="form-control"
    :class="{ 'is-invalid': invalid }"
    :disabled
    @blur="$emit('blur')"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    id: string;
    modelValue?: string | null;
    type?: "text" | "email" | "date";
    invalid?: boolean;
    disabled?: boolean;
  }>(),
  { modelValue: null, type: "text", invalid: false, disabled: false }
);

// Not defineModel: its single type can't say the input reads an absent value but only ever writes a set one.
const emit = defineEmits<{
  "update:modelValue": [value: string];
  blur: [];
}>();

// v-model rather than :value + @input, so typing through an IME composition isn't emitted mid-word.
const inputValue = computed({
  get: () => props.modelValue ?? "",
  set: (value: string) => emit("update:modelValue", value),
});
</script>
